export function formatCurrency(cents: number, multiplier = 1) {
  return ((cents * multiplier) / 100).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
}
